import React, {useEffect, useRef, useState} from "react";
import "./style.scss";
import { useTranslation } from "react-i18next";
import { ReactComponent as ClearImg } from "../../assets/icons/x.svg";
import NumKeyboard from "../NumKeyboard";

export interface TableFilterProps {
    onChange: (text: string) => void;
}

const TableFilter = ({onChange}: TableFilterProps) => {
    const [t] = useTranslation();
    const inputRef = useRef(null);
    const clearRef = useRef(null);

    const [isShow, setIsShow] = useState<boolean>(false);
    const [text, setText] = useState<string>("");

    useEffect(() => {
        onChange(text);
    }, [text]);

    const onChangeTextInput = (text: string) => {
        setText(!isNaN(parseInt(text, 10)) ? parseInt(text, 10).toString() : "");
    }

    const onChangeText = (text: string) => {
        setText(!isNaN(parseInt(text, 10)) ? parseInt(text, 10).toString() : "");
    }

    return <div className="TableFilter">
        <div className="button" onClick={() => setIsShow(!isShow)}>{t("filter")}</div>
        {isShow
            ? <div className="filterContent">
                <div className="inputContainer">
                    <div className="input">{text}</div>
                    <ClearImg ref={clearRef} className="clear" />
                </div>
                <input ref={inputRef} className="inputHide" type="text" value={text} onChange={(e) => onChangeTextInput(e.target.value)} />
                <NumKeyboard clearRef={clearRef} onChangeText={onChangeText} text={text} />
            </div>
            : null
        }
    </div>
}

export default TableFilter;
